import consts from '@/static/js/consts';
import AuthService from './AuthService';

let userActivityTimeout = null;
const activityEvents = [
  'mousemove',
  'keydown',
  'scroll',
  'resize',
];

function inactiveUserAction() {
  AuthService.LogOut();
  const event = new CustomEvent('change-route', { detail: consts.ROUTES.AUTH_LOGIN.NAME });
  window.dispatchEvent(event);
}

function resetUserActivityTimeout() {
  clearTimeout(userActivityTimeout);
  userActivityTimeout = setTimeout(() => {
    inactiveUserAction();
  }, 15 * 60 * 1000);
}

export default {
  init() {
    activityEvents.forEach((event) => {
      window.addEventListener(event, resetUserActivityTimeout);
    });
  },
  destroy() {
    activityEvents.forEach((event) => {
      window.addEventListener(event, resetUserActivityTimeout);
    });
  },
};
